<template>
    <client-page>
        <guide-visual v-bind="visual" />

        <section>
            <v-card img="/images/guide/honors/bg.jpg" tile flat class="py-40">
                <v-container>
                    <v-row align="center">
                        <v-col cols="12" lg="6">
                            <v-img src="/images/guide/honors/honors-card.svg" class="d-flex justify-center align-center">
                                <div class="text-center">
                                    <div class="font-size-20 font-size-lg-36 font-aggro font-weight-medium primary--text">
                                        With You, With CAN <br />
                                        Honors Club
                                    </div>
                                    <p class="page-text page-text--lg primary--text mt-4">위드캔 아너스클럽</p>
                                </div>
                            </v-img>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <v-row>
                                <v-col cols="12">
                                    <div class="tit tit--sm font-weight-medium">
                                        나눔을 실천하며 <br />
                                        위드캔복지재단과 함께 하는 나눔리더
                                    </div>
                                </v-col>
                                <v-col cols="12">
                                    <contact-dialog>
                                        <template #activator="{ on, attrs }">
                                            <v-btn v-on="on" v-bind="attrs" large rounded="pill" width="220" class="primary--text">
                                                <span class="font-size-lg-20">기부 상담하기</span>
                                                <v-icon small class="ml-10">mdi-chevron-right</v-icon>
                                            </v-btn>
                                        </template>
                                    </contact-dialog>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </section>

        <div class="client-content-wrap">
            <scrolldown-tail />

            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap" >
                        <h2 class="section-title">위드캔 아너스클럽 회원 기준</h2>
                    </div>

                    <v-card outlined class="border-radius-16 overflow-hidden pa-12 pa-lg-0">
                        <v-row align="center">
                            <v-col cols="6" class="d-none d-lg-block">
                                <v-img src="/images/guide/honors/member.jpg" alt="" />
                            </v-col>
                            <v-col cols="12" lg="6">
                                <v-row class="row--xxs">
                                    <v-col cols="12">
                                        <v-row align="center">
                                            <v-col cols="auto">
                                                <v-sheet color="#f5f5f5" class="standard-stage">
                                                    <div class="tit tit--sm primary--text">정회원</div>
                                                </v-sheet>
                                            </v-col>
                                            <v-col>
                                                <p class="page-text page-text--lg grey-1--text">현금 2천만원 이상을 기부한 개인 후원자</p>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-row align="center">
                                            <v-col cols="auto">
                                                <v-sheet color="primary lighten-4" class="standard-stage">
                                                    <div class="tit tit--sm">약정회원</div>
                                                </v-sheet>
                                            </v-col>
                                            <v-col>
                                                <p class="page-text page-text--lg grey-1--text">
                                                    현금 2천만원을 3년 내 <br />
                                                    기부하기로 약정한 개인 후원자
                                                </p>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-row align="center">
                                            <v-col cols="auto">
                                                <v-sheet color="primary" class="standard-stage">
                                                    <div class="tit tit--sm white--text">리더회원</div>
                                                </v-sheet>
                                            </v-col>
                                            <v-col>
                                                <p class="page-text page-text--lg grey-1--text">
                                                    현금 2천만원을 후원하며, <br />
                                                    가족 또는 제3자를 회원으로 추대한 개인 후원자
                                                </p>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-container>
            </section>

            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap" >
                        <h2 class="section-title">위드캔 아너스클럽 가입 절차</h2>
                    </div>

                    <v-img src="/images/guide/honors/process-list.png" alt="" class="d-md-none" />

                    <div class="d-none d-md-block">
                        <v-row class="process-list row--lg">
                            <v-col v-for="(item, index) in process" :key="index" cols="12" lg="3">
                                <v-card color="#FAFAFA" flat class="process-card">
                                    <v-row class="text-center">
                                        <v-col cols="12">
                                            <div class="primary--text font-weight-bold font-size-28">0{{ index + 1 }}</div>
                                            <div v-html="item.name" class="client-title--xs font-weight-bold mt-16" />
                                            <v-img :src="`/images/guide/honors/process-${index + 1}.svg`" max-width="60" class="my-28 mx-auto" />
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>
            </section>

            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap" >
                        <h2 class="section-title word-keep-all">
                            위드캔 아너스클럽 후원자 <br class="d-md-none">
                            예우
                        </h2>
                    </div>

                    <v-row>
                        <v-col v-for="(item, index) in respect" :key="index" cols="12" md="6" lg="3">
                            <v-card color="#ddd" max-width="282" outlined class="mx-auto text-center h-100 border-radius-16">
                                <v-img :src="item.image" alt="" />
                                <v-card-title class="justify-center pt-lg-24">
                                    <div v-html="item.title" class="tit tit--sm primary--text" />
                                </v-card-title>
                                <v-card-text class="pb-lg-24">
                                    <p v-html="item.texts" />
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                    <div class="mt-24">
                        <v-divider />
                        <p class="page-text text-center py-16">위드캔복지재단은 지정기부금 단체로 기부금 1천만원 이하 15%, 1천만원 초과 30%까지연말정산 시 세액공제 혜택을 받으실 수 있습니다.</p>
                        <v-divider />
                    </div>
                </v-container>
            </section>
        </div>
    </client-page>
</template>

<script>
import GuideVisual from "@/components/client/guide/guide-visual.vue";
import ClientPage from "../templates/ClientPage.vue";
import ScrolldownTail from "@/components/dumb/scrolldown-tail.vue";
import SponsorSlide from "@/components/client/dumb/sponsor-slide.vue";
import GoodsTabs from "@/components/client/guide/goods-tabs.vue";
import Faq from "../board/community/Faq.vue";
import FaqList from "@/components/client/dumb/faq-list.vue";
import ContactDialog from "@/components/client/dumb/contact-dialog.vue";

export default {
    components: {
        ClientPage,
        GuideVisual,
        ScrolldownTail,
        SponsorSlide,
        GoodsTabs,
        Faq,
        FaqList,
        ContactDialog,
    },
    data() {
        return {
            visual: {
                image: "/images/guide/honors/visual.jpg",
                title: "위드캔 아너스클럽",
                texts: "위드캔 아너스클럽은 자발적인 참여와 기부활동을 통해 <br />어려운 이웃들에게 더 큰 변화를 만들어내는 고액후원자클럽입니다.",
                mobile: "/images/guide/honors/mobile-visual.jpg",
            },

            types: [
                {
                    icon: "/images/guide/legacy/type-1.svg",
                    name: "현금",
                },
                {
                    icon: "/images/guide/legacy/type-2.svg",
                    name: "부동산",
                },
                {
                    icon: "/images/guide/legacy/type-3.svg",
                    name: "보험",
                },
                {
                    icon: "/images/guide/legacy/type-4.svg",
                    name: "증권",
                },
                {
                    icon: "/images/guide/legacy/type-5.svg",
                    name: "신탁",
                },
                {
                    icon: "/images/guide/legacy/type-6.svg",
                    name: "귀중품",
                },
            ],

            process: [
                {
                    name: "1:1 기부상담",
                },
                {
                    name: "기부금 전달식",
                },
                {
                    name: "클럽등재",
                },
                {
                    name: "결과보고",
                },
            ],

            respect: [
                {
                    image: "/images/guide/honors/respect-1.jpg",
                    title: "개별 약정식 및 헌액식",
                    texts: "후원액 및 약정 조건을 명확히 하고, <br class='d-none d-xl-block' />협약 체결을 기념합니다.",
                },
                {
                    image: "/images/guide/honors/respect-2.jpg",
                    title: "명예의 전당 등재",
                    texts: "재단 홈페이지나 현판 등에 <br class='d-none d-xl-block' />후원자명을 등재하여 <br class='d-none d-xl-block' />나눔의 가치를 기립니다.",
                },
                {
                    image: "/images/guide/honors/respect-3.jpg",
                    title: "현장활동",
                    texts: "해외·국내 복지사업 현장을 <br class='d-none d-xl-block' />직접 방문해, 나눔의 현장을 <br class='d-none d-xl-block' />체험합니다.",
                },
                {
                    image: "/images/guide/honors/respect-4.jpg",
                    title: "위드캔아너스클럽 <br />회원모임",
                    texts: "정기 모임과 네트워킹을 통해 <br class='d-none d-xl-block' />함께하는 기쁨을 나눕니다.",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.standard-stage {
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 150px;
    height: 80px;
}
.process-list {
    > [class*="col"] {
        .process-card {
            padding: 40px 14px;
            height: 100%;
            border-radius: 16px;
            max-width: 400px;
            margin: 0 auto;
            word-break: keep-all;
        }
        &:not(:last-child) {
            .process-card {
                position: relative;
                &::after {
                    content: "";
                    position: absolute;
                    right: 50%;
                    bottom: -28px;
                    transform: translateX(50%) rotate(90deg);
                    width: 24px;
                    height: 24px;
                    background: url(/images/guide/legacy/process-arrow.svg) no-repeat center;
                }
            }
        }
    }
}
@media (min-width: 768px) {
    .standard-stage {
        width: 190px;
        height: 104px;
    }
}
@media (min-width: 1024px) {
    .process-list {
        > [class*="col"] {
            &:not(:last-child) {
                .process-card {
                    position: relative;
                    &::after {
                        content: "";
                        position: absolute;
                        right: -32px;
                        bottom: 50%;
                        transform: translatey(50%);
                        width: 24px;
                        height: 24px;
                    }
                }
            }
        }
    }
}
</style>